import { css, cx } from '@emotion/css'
import { theme } from '../styles/theme.js'

const styles = {
  header: css({
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    height: '56px',
    backgroundColor: theme.colors.surface,
    borderBottom: `1px solid ${theme.colors.border}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `0 ${theme.spacing.lg}`,
    zIndex: 100,
    paddingTop: 'env(safe-area-inset-top, 0px)',
  }),
  logo: css({
    fontSize: theme.typography.fontSize.xl,
    fontWeight: 700,
    letterSpacing: '-0.02em',
  }),
  accent: css({
    color: theme.colors.primary,
  }),
  actions: css({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing.sm,
  }),
}

const Header = ({ children }) => {
  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        oakshi<span className={styles.accent}>genesis</span>
      </div>
      <div className={styles.actions}>{children}</div>
    </header>
  )
}

export { Header }
